// import esriId from "@arcgis/core/identity/IdentityManager";
import { createContext, useContext, useReducer, useMemo } from "react";
import PropTypes from "prop-types";
// Lookups context
const responsiveContext = createContext();
// Setting custom name for the context which is visible on react dev tools
responsiveContext.displayName = "Responsive Context";

// reducer
function reducer(state, action) {
  switch (action.type) {
    case "INIT": {
      return { ...state, ...action.payload };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// context provider
function ResponsiveContextProvider({ children }) {
  const initialState = {
    contentClass: "full-open",
    sidebarClass: "close",
  };
  const [controller, dispatch] = useReducer(reducer, initialState);
  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

  return (
    <responsiveContext.Provider value={value}>
      {children}
    </responsiveContext.Provider>
  );
}

ResponsiveContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// custom hook for using context
function useResponsive() {
  const context = useContext(responsiveContext);

  if (!context) {
    throw new Error(
      "useResponsive should be used inside the ResponsiveContextProvider."
    );
  }

  return context;
}

// context functions

function setResponsiveContext(dispatch, newState) {
  dispatch({ type: "INIT", payload: { ...newState } });
}

function handleChangeContentLayout(
  responsiveDispatch,
  { close = false, contentClass = "full-open" }
) {
  // full-open
  // part-open
  // no-open
  if (close) {
    responsiveDispatch({
      type: "INIT",
      payload: { contentClass: "no-open" },
    });
    return;
  }
  if (contentClass === "no-open" || contentClass === "part-open") {
    responsiveDispatch({
      type: "INIT",
      payload: { contentClass: "full-open" },
    });
    return;
  }
  responsiveDispatch({
    type: "INIT",
    payload: { contentClass: "part-open" },
  });
}
function handleChangeSidebarState(responsiveDispatch, { sidebarClass = "" }) {
  if (sidebarClass === "close")
    responsiveDispatch({
      type: "INIT",
      payload: { sidebarClass: "open" },
    });
  else
    responsiveDispatch({
      type: "INIT",
      payload: { sidebarClass: "close", contentClass: "full-open" },
    });
}

export {
  ResponsiveContextProvider,
  useResponsive,
  setResponsiveContext,
  handleChangeContentLayout,
  handleChangeSidebarState,
};
